import stylesheet from './ImageGalleryLarge.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

const TILE_CONFIG: { ratio: string; column: 'left' | 'right' }[] = [
    { ratio: '4 / 3', column: 'left' },
    { ratio: '16 / 9', column: 'left' },
    { ratio: '16 / 9', column: 'right' },
    { ratio: '4 / 3', column: 'right' },
];

class NXTImageGalleryLarge extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    applyTileConfig() {
        const tiles = Array.from(this.children) as HTMLElement[];
        tiles.forEach((tile, index) => {
            const config = TILE_CONFIG[index];
            if (!config) return;
            tile.setAttribute('aspect-ratio', config.ratio);
            tile.setAttribute('slot', config.column);
        });
    }

    render() {
        this.applyTileConfig();
        const container = document.createElement('div');
        container.classList.add('gallery');
        container.innerHTML = `
            <div class="column"><slot name="left"></slot></div>
            <div class="column"><slot name="right"></slot></div>
        `;
        return container;
    }
}

customElements.define('nxt-image-gallery-large', NXTImageGalleryLarge);
